<template>
  <AutoComplete
    v-model="myValue"
    :data="fileList"
    :filter-method="filterMethod"
    :placeholder="placeholder"
    :size="size"
    :disabled="disabled"
  ></AutoComplete>
</template>

<script>
import { getUploadFiles } from '@/api/upload'
import nodeID from '@/mixins/nodeID'

export default {
  name: 'FileListAutoCompeleteSeletor',

  mixins: [nodeID],

  props: {
    value: { type: String, default: '' },
    size: { type: String, default: 'large' },
    prefix: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: 'http://127.0.0.1:63767/kuiper-plugins/0.9.1/sinks/alpine/file_arm64.zip' },
  },

  data() {
    return {
      myValue: '',
      fileList: [],
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newV) {
        this.myValue = newV
      },
    },
    myValue: {
      immediate: true,
      handler(newV) {
        this.$emit('input', newV)
      },
    },
  },

  created() {
    this.getFileList()
  },

  methods: {
    getFileList() {
      getUploadFiles(this.nodeID).then((res) => {
        if (res?.data) {
          this.fileList = res.data.map((item) => {
            return `${this.prefix}${item}`
          })
        }
      })
    },
    filterMethod(value, option) {
      return option.toUpperCase().indexOf(value.toUpperCase()) !== -1
    },
  },
}
</script>
